export const CookieKeys = {
  AUTH_TOKEN: 'auth_token',
  ORDER_TOKEN: 'order_token',
  ORDER_SHIPMENT: 'order_shipment',
  ALERT_MESSAGES_DISMISSED: 'alert_messages_dismissed',
  AUTH_REFRESH_TOKEN: 'auth_refresh_token',
  AUTH_REFRESH_TOKEN_EXPIRATION: 'auth_refresh_token_expiration',
  CART: 'cart',
  PRODUCTS_COMPARISON: 'products_comparison',
} as const;

export type CookieOptions = {
  expires?: number | Date;
  path?: string;
  domain?: string;
  secure?: boolean;
  sameSite?: 'strict' | 'lax' | 'none';
  httpOnly?: boolean;
  maxAge?: number;
};

export const DefaultCookieOptions: CookieOptions = {
  path: '/',
  // TODO: config values
  secure:
    process.env.NODE_ENV === 'production' && process.env.NEXT_PUBLIC_COOKIE_SECURE !== 'false',
  sameSite: 'lax',
} as const;

export const AUTH_TOKEN_MAX_AGE = 2 * 60 * 60;
export const AUTH_REFRESH_TOKEN_MAX_AGE = 30 * 24 * 60 * 60;
export const ORDER_TOKEN_MAX_AGE = 7 * 24 * 60 * 60;
export const ORDER_SHIPMENT_MAX_AGE = 7 * 24 * 60 * 60;
export const ALERT_MESSAGES_DISMISSED_MAX_AGE = 365 * 24 * 60 * 60;
export const PRODUCTS_COMPARISON_MAX_AGE = 365 * 24 * 60 * 60;
